<template>
  <div class="mqttDeviceCopy">
    <div class="mqttDeviceContent">
      <div class="searchBox">
        <el-form>
          <div class="searchPox" style="width: 100%;display: flex;justify-content: space-between;align-items: center">
            <div style="display: flex;align-items: center">
              <el-select v-model="searchSelect1" style="width: 100px;margin-right: 8px">
                <el-option label="设备名称" value="1"></el-option>
                <el-option label="网关ID" value="2"></el-option>
              </el-select>
              <div v-show="searchSelect1==2" class="liBox">
                <el-form-item label="">
                  <el-input v-model="gatewayId" autocomplete="off" clearable placeholder='请输入网关ID'
                            type="text"></el-input>
                </el-form-item>
              </div>
              <div v-show="searchSelect1==1" class="liBox">
                <el-form-item label="">
                  <el-input v-model="name" autocomplete="off" clearable placeholder='请输入设备名称' type="text"
                            @change="nameChange"></el-input>
                </el-form-item>
              </div>
              <el-button class="searchButton" style="margin-right: 16px" type="primary" @click="getListFun">查询
              </el-button>
              <div class="liBox" style="width: 252px">
                <el-form-item label="设备状态">
                  <el-radio-group v-model="useStatus" @change="getListFun">
                    <el-radio value="">全部</el-radio>
                    <el-radio value="1">在线</el-radio>
                    <el-radio value="0">离线</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <el-checkbox v-model="getSubFlag" label="显示下级" size="large" style="margin-right: 16px;"
                           @change="showNextLevel"/>
              <el-popover popper-class="moreOpera2" trigger="hover">
                <div class="listPox">
                  <el-button v-if="addDeviceLimit" :disabled="custerObj.nodeType==2?true:false"
                             @click="addClick()">新建设备
                  </el-button>
                  <el-button v-if="addDeviceLimit" :disabled="custerObj.nodeType==2?true:false"
                             @click="importClick()">导入设备
                  </el-button>
                  <el-button @click="exportClick">导出模版</el-button>
                </div>
                <template #reference>
                  <el-button style="border: 0;background: rgba(22, 93, 255, .1);color: #165DFF;">操作</el-button>
                </template>
              </el-popover>
              <el-popover popper-class="moreOpera2" trigger="hover">
                <div class="listPox">
                  <el-button @click="bindGroupClick('1')">峰谷</el-button>
                  <el-button @click="bindGroupClick('2')">电价</el-button>
                </div>
                <template #reference>
                  <el-button style="border: 0;background: rgba(22, 93, 255, .1);color: #165DFF;">设置</el-button>
                </template>
              </el-popover>
            </div>
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/screenIcon.png"
                 style="width: 32px;height: 32px"
                 @click="enterFullScreen()">


            <div v-if="false" class="liBox searchBtn">
              <el-button class="searchButton" type="primary" @click="getListFun">查询</el-button>
              <el-button v-if="addDeviceLimit" :disabled="custerObj.nodeType==2?true:false" :icon="Plus" type="primary"
                         @click="addClick()">
                新建设备
              </el-button>
              <el-button type="primary">
                <el-checkbox v-model="getSubFlag" label="" size="large" @change="showNextLevel"/>
                显示下级
              </el-button>
              <el-button v-if="addDeviceLimit" :disabled="custerObj.nodeType==2?true:false" type="primary"
                         @click="importClick()">导入设备
              </el-button>
              <div style="display: none;">
                <el-upload v-model:file-list="fileList" :auto-upload="false" :show-file-list="false" accept=".xls,.xlsx"
                           action="#" class="upload-demo"
                           @change="uploadFile2">
                  <el-button id="fileName" style="margin: 0 12px;" type="primary" @click="">
                    导入
                  </el-button>
                </el-upload>
              </div>
              <el-button style="margin-left: 12px;" type="primary" @click="exportClick">导出模版</el-button>
              <el-button style="margin-left: 12px;" type="primary"
                         @click="bindGroupClick('1')">
                添加峰谷、电价
              </el-button>
              <el-button style="margin-left: 12px;" @click="enterFullScreen()">全屏展示</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="tableBox">
        <!--列表-->
        <div class="tableBox">
          <el-table ref="multipleTableRef" v-loading='loadingVal' :data="deviceList" :row-key="rowKey"
                    style="width: 100%" table-layout="auto" @selection-change="handleSelectionChange">
            <template #empty>
              <el-empty class="emptyClass" description="暂无数据信息" image="
https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
                <p>您可以在此页面绑定设备</p>
              </el-empty>
            </template>
            <el-table-column :reserve-selection="true" type="selection" width="55"/>
            <el-table-column label="设备名称" min-width="150px" prop="name"/>
            <el-table-column label="设备地址" min-width="150px" prop="address"/>
            <el-table-column label="网关ID" min-width="150px" prop="dId"/>
            <el-table-column label="状态" min-width="150px" property="useStatusStr">
              <template #default="scope">
                <div v-show="scope.row.useStatus==1" class='statusOnClass'>
                  <div class="dotOnClass"></div>
                  {{ scope.row.useStatusStr }}
                </div>
                <div v-show="scope.row.useStatus==0" class='statusOutClass'>
                  <div class="dotOutClass"></div>
                  {{ scope.row.useStatusStr }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="产品型号" min-width="150px" prop="productModel"/>
            <!--            <el-table-column label="创建人" min-width="150px" prop="creatorName"/>-->
            <el-table-column label="最后通讯时间" min-width="150px" prop="lastTime" sortable/>
            <el-table-column fixed="right" label="操作" width="150">
              <template #default="scope">
                <ul class="operationUl">
                  <li v-if="editDeviceLimit" v-show="custerObj.nodeType!=2" class="editClass"
                      @click="addClick(scope.row.id)">
                    <el-tooltip content="编辑" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear1.png">
                    </el-tooltip>
                  </li>
                  <li class="editClass"
                      @click="managementClick(scope.row.id,scope.row.idStr,scope.row.name,scope.row.equipmentId)">
                    <el-tooltip content="数据" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear2.png">
                    </el-tooltip>
                  </li>
                  <li class="editClass" @click='goWarnFun(scope.row.id,scope.row.idStr)'>
                    <el-tooltip content="报警" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear5.svg">
                    </el-tooltip>
                  </li>
                  <!--                  <li v-if="delDeviceLimit" v-show="custerObj.nodeType!=2" class="editClass"-->
                  <!--                      @click="deleteClick(scope.row.id)">-->
                  <!--                    <el-tooltip content="删除" effect="light" placement="top">-->
                  <!--                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear4.svg">-->
                  <!--                    </el-tooltip>-->
                  <!--                  </li>-->
                  <li v-if="editDeviceLimit" class="editClass"
                      @click="bindGroupClick('1',scope.row.id,scope.row.idStr)">
                    <el-tooltip content="添加峰谷、电价" effect="light" placement="top">
                      <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear6.svg">
                    </el-tooltip>
                  </li>
                  <!--                  <li class="editClass">-->
                  <!--                    <el-popover popper-class="moreOpera2" trigger="hover">-->
                  <!--                      <div class="listPox">-->
                  <!--                        <p @click='goWarnFun(scope.row.id,scope.row.idStr)'>报警</p>-->
                  <!--                        <p v-if="delDeviceLimit" v-show="custerObj.nodeType!=2" @click="deleteClick(scope.row.id)">-->
                  <!--                          删除</p>-->
                  <!--                      </div>-->
                  <!--                      <template #reference>-->
                  <!--                        <p class="more">-->
                  <!--                          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectOpear3.png">-->
                  <!--                        </p>-->
                  <!--                      </template>-->
                  <!--                    </el-popover>-->
                  <!--                  </li>-->
                </ul>
              </template>
            </el-table-column>
          </el-table>
          <div class="footerBox">
            <el-pagination :disabled="disabled" :page-size="pageSize" :page-sizes="[20,100, 200, 300, 400]"
                           :total="total" background layout="total,sizes, prev, pager, next" small
                           @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
          </div>
        </div>
      </div>
    </div>
    <!--新增设备弹窗-->
    <el-dialog v-model="deviceDialogVisible" :close-on-click-modal="false" :title="deviceForm.id?'编辑设备':'新增设备'"
               width="40%">
      <div>
        <el-form ref="deviceFormRef" :model="deviceForm" :rules="deviceRules" class="demo-ruleForm" label-width="auto"
                 style="width:98%">
          <el-form-item label="设备名称" prop="name">
            <el-input v-model="deviceForm.name" placeholder="请输入设备名称"/>
          </el-form-item>
          <el-form-item label="产品型号" prop="productId">
            <el-select v-model="deviceForm.productId" clearable placeholder="请选择产品型号" style="width:100%">
              <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"
                         style="width:100%">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="网关ID" prop="dId">
            <el-input v-model="deviceForm.dId" placeholder="请输入网关ID"/>
          </el-form-item>
          <el-form-item label="通讯地址" prop="address">
            <el-input v-model="deviceForm.address" placeholder="请输入通讯地址" @change="addressChange"/>
          </el-form-item>
          <el-form-item label="密码" prop="pwd">
            <el-input v-model="deviceForm.pwd" placeholder="请输入密码"/>
          </el-form-item>
          <el-form-item label="是否启用" prop="enableFlag">
            <el-select v-model="deviceForm.enableFlag" clearable filterable placeholder="请选择是否启用"
                       style="width:100%">
              <el-option v-for="item in enableList" :key="item.id" :label="item.name" :value="item.id"
                         style="width:100%">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="deviceForm.remark" placeholder="请输入备注"/>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
				<span class="dialog-footer">
		    		<el-button class="resetButton" @click="deviceDialogVisible = false">取消</el-button>
		    		<el-button type="primary" @click="deviceSave">保存</el-button>
      			</span>
      </template>
    </el-dialog>
    <!--绑定组合包弹窗-->
    <el-dialog v-model="bindGroupVisible" :close-on-click-modal="false" title="添加峰谷组合" width="80%">


      <el-tabs v-model="tabIdx" class="demo-tabs">
        <el-tab-pane label="峰谷" name="1">
          <div class="addRateMix">
            <div style="display: flex;align-items: center;margin-bottom: 20px">
              <span style="margin-right: 10px">峰谷组合</span>
              <el-select v-model="bindGroupId" class="bagClass" clearable placeholder="请选择峰谷组合"
                         style="width: 220px;">
                <el-option v-for="(item,index) in electrovalenceBagList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="content" style="padding: 0;width: 100%;">
              <DetailModule v-if="bindGroupId" :id="bindGroupId"/>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="电价" name="2">
          <div class="addRateMix">
            <div style="display: flex;align-items: center;margin-bottom: 20px">
              <span style="margin-right: 10px">电价</span>
              <el-select v-model="bindPriceId" class="bagClass" clearable placeholder="请选择电价"
                         style="width: 220px;">
                <el-option v-for="(item,index) in elePriceList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="content" style="padding: 0;width: 100%;">
              <ElePriceDetail v-if="bindPriceId" :id="bindPriceId"/>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <template #footer>
				<span class="dialog-footer">
        <el-button class="cancle resetButton" @click="bindGroupVisible=false">取消</el-button>
        <el-button class="confrim" type="primary" @click="bindGroupSave()">保存</el-button>
      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import {defineProps, h, onMounted, ref, watch} from "vue"
import {useRouter} from "vue-router/dist/vue-router";
import qs from "qs";
import {ElLoading, ElMessage, ElMessageBox} from "element-plus";
import {
  deleteMqttList,
  getMqttDetail,
  getMqttProductList,
  importMqttDeviceList,
  saveMqttList
} from "@/api/modules/device";
import {http} from "@/api";
import DetailModule from '../../rateManagement/addRateMix/detailModule'
import ElePriceDetail from '../../rateManagement/elePrice/elePriceDetail'
import {
  bindElePricePlanListApi,
  getElePricePlanListSelectApi,
  getEquipmentMqttWithPowerPriceListApi,
  getPowerPriceGroupListByPrefixEquipmentIdApi,
  updateGroupEquipmentApi
} from "@/api/modules/rate";

const props = defineProps(['custerObj', 'mainType', 'mainId']);
let router = useRouter()
let route = useRouter()

// 搜索操作
let searchSelect1 = ref('1')


// 获取列表-------------------------------------------------------------------------
//设备名称的改变
const nameChange = function () {
  window.localStorage.setItem('name', name.value)
}
let pageNumber = ref(1) //页码
let pageSize = ref(20) //页数
let total = ref(0) //总页数
let tableData = ref([]) //列表数据
//重置

//每页多少
const handleSizeChange = function (val) {
  pageSize.value = val;
  getListFun();
}
//更改页数
const handleCurrentChange = function (val) {
  pageNumber.value = val;
  getListFun();
}
let loadingVal = ref(false) //表格加载
let name = ref() //设备名称
let gatewayId = ref() //网关id
let useStatus = ref('') //状态
let getSubFlag = ref(true) //状态
//获取设备列表
let deviceList = ref([])
const getListFun = async function () {
  if (custerObj.value.id) {
    loadingVal.value = true
    let params = {
      pageNumber: pageNumber.value,
      pageSize: pageSize.value,
      projectId: custerObj.value.id,
      getSubFlag: getSubFlag.value ? 1 : 0,
      name: name.value,
      useStatus: useStatus.value,
      dId: gatewayId.value,
      mainType: props.mainType,
      mainId: props.mainId,
    }
    await getEquipmentMqttWithPowerPriceListApi(qs.stringify(params)).then(res => {
      loadingVal.value = false
      if (res.data.ok) {
        deviceList.value = res.data.result.list
        total.value = Number(res.data.result.total)
      } else {
        ElMessage({
          message: res.data.message,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }
}


// 显示下级-------------------------------------------------------------------------
const showNextLevel = function () {
  getListFun()
}


// 新增操作-------------------------------------------------------------------------
let deviceDialogVisible = ref(false) //新增设备弹窗开关
let editId = ref() //编辑id
let enableList = ref([{
  id: 1,
  name: '是'
}, {
  id: 0,
  name: '否'
}])
//新增设备的点击
const addClick = function (id) {
  deviceDialogVisible.value = true
  if (id) {
    editId.value = id
    getMqttDetail(qs.stringify({
      id: id
    })).then(res => {
      if (res.data.ok) {
        deviceForm.value.id = res.data.result.id
        deviceForm.value.name = res.data.result.name
        deviceForm.value.productId = res.data.result.productId
        deviceForm.value.dId = res.data.result.dId
        deviceForm.value.address = res.data.result.address
        deviceForm.value.pwd = res.data.result.pwd
        deviceForm.value.enableFlag = res.data.result.enableFlag
        deviceForm.value.projectId = custerObj.value.id
        deviceForm.value.remark = res.data.result.remark
      } else {
        ElMessage({
          message: res.data.message,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    })
  } else {
    deviceForm.value = {
      id: 0,
      name: '',
      productId: '',
      dId: '',
      address: '',
      pwd: '',
      projectId: custerObj.value.id,
      enableFlag: 1,
      remark: '',
    }
  }
}

let deviceFormRef = ref() //设备
//设备表单
let deviceForm = ref({
  id: 0,
  name: '',
  productId: '',
  dId: '',
  address: '',
  pwd: '',
  projectId: '',
  enableFlag: 1,
  remark: '',
})
// 设备表单验证规则
let deviceRules = ref({
  name: [{
    required: true,
    message: '请输入设备名称',
    trigger: 'blur'
  }],
  productId: [{
    required: true,
    message: '请选择产品型号',
    trigger: 'blur'
  }],
  dId: [{
    required: true,
    message: '请输入网关id',
    trigger: 'blur'
  }],
  address: [{
    required: true,
    message: '请输入通讯地址',
    trigger: 'blur'
  }],
  pwd: [{
    required: true,
    message: '请输入密码',
    trigger: 'blur'
  }],
  enableFlag: [{
    required: true,
    message: '请选择是否启用',
    trigger: 'blur'
  }]
})
//设备的保存
const deviceSave = function () {
  if (deviceFormRef) {
    deviceFormRef.value.validate((valid) => {
      //提交成功
      if (valid) {
        saveMqttList(
            qs.stringify(deviceForm.value)
        ).then(async res => {
          if (res.data.ok) {
            deviceDialogVisible.value = false
            getListFun()
          } else {
            ElMessage({
              message: res.data.message,
              type: 'error'
            })
          }
        }).catch(err => {
          console.log(err);
        })
      }
    })
  }
}
//删除
const deleteClick = function (id) {
  ElMessageBox.confirm("确认删除吗，删除后不可恢复，请谨慎操作", '', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除设备',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }, ''),
      h('span', {
        style: 'color:#595959;'
      }, '请确认是否要删除此设备，删除后数据不可恢复'),
    ])
  }).then(() => {
    deleteMqttList(qs.stringify({
          id: id
        })
    ).then(res => {
      if (res.data.ok) {
        getListFun()
      } else {
        ElMessage({
          message: res.data.message,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      message: '已取消删除',
      type: 'info',
    })
  });
}


// 导入设备---------------------------------------------------------------
let personData = ref({}) //自定义上传参数
let fileList = ref([]) //上传文件
const importClick = function () {
  document.getElementById("fileName").click();
}
const uploadFile2 = function (file) {
  let fd = new FormData();
  fd.append('file', file.raw);
  importMqttDeviceList(fd).then(res => {
    if (res && res.data && res.data.ok) {
      //console.log(res)
      getListFun()
      ElMessage({
        type: 'success',
        message: '导入成功！'
      });
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}

// 加载的动画
let loadingAdd = ref()
const openFullScreen = function () {
  loadingAdd.value = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.1)'
  })
}
// 导出模版
const exportClick = function () {
  openFullScreen();
  setTimeout(() => {
    loadingAdd.value.close();
    ElMessage({
      type: 'success',
      message: '导出成功'
    });
  }, 2000);
  window.location.href = http + 'zouk/rest/equipmentMqtt/exportTemplate?projectId=' + custerObj.value.id + '&memberId=' + window.localStorage.getItem('memberId')
}


//管理
const managementClick = function (id, idStr, equipmentName, equipmentId) {
  window.open(`#/admin/projectData?isLocal=${custerObj.value.nodeType}&id=${id}&idStr=${idStr}&type=4&equipmentName=${encodeURIComponent(equipmentName)}&projectName=${custerObj.value.name}&equipmentId=${equipmentId}`, '_blank');
}
// 点击报警
const goWarnFun = function (id, idStr) {
  window.open(`#/admin/projectWarning?id=${idStr}`, '_blank');
}


// 进入全屏
const enterFullScreen = () => {
  // 获取layout的dom元素
  const parentNode = document.querySelector('.rightBox'); // 获取需要全屏的元素;
  // document.querySelector('.largeScreenContent .chart').style.height = 'calc(100% - 140px)'  //进入全屏后变大图片
  // 进入全屏
  if (parentNode.requestFullscreen) {
    parentNode.requestFullscreen();
  } else if (parentNode.webkitRequestFullScreen) {
    parentNode.webkitRequestFullScreen();
  } else if (parentNode.mozRequestFullScreen) {
    parentNode.mozRequestFullScreen();
  } else if (parentNode.msRequestFullscreen) {
    // IE11
    parentNode.msRequestFullscreen();
  }


};
// 退出全屏
const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if ((document).webkitCancelFullScreen) {
    (document).webkitCancelFullScreen();
  } else if ((document).mozCancelFullScreen) {
    (document).mozCancelFullScreen();
  } else if ((document).msExitFullscreen) {
    (document).msExitFullscreen();
  }

};


// 表格多选框选择事件
let checkIdArr = ref([])
let checkIdArrStr = ref([])
const rowKey = function (row) {
  return row.id
}
const handleSelectionChange = function (e) {
  checkIdArr.value = []
  for (let i = 0; i < e.length; i++) {
    checkIdArr.value.push(Number(e[i].id))
  }
  checkIdArr.value = [...new Set(checkIdArr.value)]
  checkIdArrStr.value = []
  for (let i = 0; i < e.length; i++) {
    checkIdArrStr.value.push(e[i].idStr)
  }
  checkIdArrStr.value = [...new Set(checkIdArrStr.value)]
}


// 绑定组合包---------------------------------------------------------------
let tabIdx = ref('1')
let bindGroupVisible = ref(false)  //绑定组合包弹窗
let bindGroupId = ref() // 组合包id
let bindPriceId = ref() // 电价id
let bindGroupEquipmentId = ref() // 绑定组合包的设备id
let bindGroupEquipmentIdStr = ref() // 绑定组合包的设备id
let electrovalenceBagList = ref([])
let elePriceList = ref([])
// 点击绑定组合包
const bindGroupClick = function (type, id, idStr) {
  tabIdx.value = type
  bindGroupEquipmentId.value = id ? id : null
  bindGroupEquipmentIdStr.value = idStr ? idStr : null
  bindGroupVisible.value = true
  // 获取峰谷组合列表
  getPowerPriceGroupListByPrefixEquipmentIdApi(qs.stringify({
    prefixId: idStr ? idStr : null,
  })).then(res => {
    if (res.data.code === 0) {
      electrovalenceBagList.value = res.data.result
      let flag = true
      for (let i = 0; i < electrovalenceBagList.value.length; i++) {
        if (electrovalenceBagList.value[i].checkFlag) {
          bindGroupId.value = electrovalenceBagList.value[i].id
          flag = false
        }
      }
      if (flag) {
        bindGroupId.value = ''
      }
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
  // 获取电价列表
  getElePricePlanListSelectApi(qs.stringify({
    equipmentId: idStr ? idStr : null,
  })).then(res => {
    if (res.data.code === 0) {
      elePriceList.value = res.data.result
      let flag = true
      for (let i = 0; i < elePriceList.value.length; i++) {
        if (elePriceList.value[i].checkFlag) {
          bindPriceId.value = elePriceList.value[i].id
          flag = false
        }
      }
      if (flag) {
        bindPriceId.value = ''
      }
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  })
}
// 绑定组合包提交
const bindGroupSave = function () {
  if (!bindGroupId.value) {
    ElMessage({
      message: '请选择峰谷包',
      type: 'info'
    })
  } else {
    updateGroupEquipmentApi(qs.stringify({
      id: bindGroupId.value,
      equipmentType: 4,
      equipmentIdList: bindGroupEquipmentId.value ? bindGroupEquipmentId.value : checkIdArr.value.join(',')
    })).then(res => {
      if (res.data.code === 0) {
        bindGroupVisible.value = false
      } else {
        ElMessage({
          message: res.data.message,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }

  bindElePricePlanListApi(qs.stringify({
    id: bindPriceId.value,
    // equipmentType: activeName.value,
    // equipmentId: bindGroupEquipmentId.value ? bindGroupEquipmentId.value : checkIdArr.value.join(',')
    equipmentIdList: bindGroupEquipmentIdStr.value ? bindGroupEquipmentIdStr.value : checkIdArrStr.value.join(',')
  })).then(res => {
    if (res.data.code === 0) {
      bindGroupVisible.value = false
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}


let addDeviceLimit = ref(false)
let editDeviceLimit = ref(false)
let delDeviceLimit = ref(false)
/*生命周期*/
let productList = ref([])
onMounted(async () => {
  // const query = {...route.query};
  // // 使用新的查询参数替换当前路由
  // router.replace({query});


  // 获取产品型号选项
  getMqttProductList().then(res => {
    if (res && res.data && res.data.ok) {
      productList.value = res.data.result
    } else {
      ElMessage({
        message: res.data.message,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })


  // 获取设备的操作权限
  let arr = JSON.parse(window.window.localStorage.getItem('menuList'))
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].menuKey === '/admin/project') {
      for (let j = 0; j < arr[i].subList.length; j++) {
        if (arr[i].subList[j].menuKey === 'addDevice') {
          addDeviceLimit.value = true
        } else if (arr[i].subList[j].menuKey === 'editDevice') {
          editDeviceLimit.value = true
        } else if (arr[i].subList[j].menuKey === 'delDevice') {
          delDeviceLimit.value = true
        }
      }
    }
  }
})

let custerObj = ref()
// 监听props.data.list中每个元素的变化，当它变化时，启动动画
watch(() => props.custerObj, async (newValues, oldValues) => {
  custerObj.value = newValues
  if (newValues.id) {
    await getListFun()
  }
}, {immediate: true, deep: true});


</script>

<style lang="less">
.mqttDeviceCopy {
  background: #fff;
  width: calc(100% - 32px);
  height: calc(100% - 25px);
  padding: 0 16px 24px;
  overflow: auto;
  border-top: 0;

  > .title {
    width: 100%;
    height: 0;
    padding: 0;

  }

  //内容
  .mqttDeviceContent {
    width: 100%;
    height: calc(100% - 36px);
    padding: 0;
    margin: 0;
    display: block;
    //搜索
    .searchBox {
      position: relative;
      width: 100%;
      margin-bottom: 16px;
      display: flex;

      .el-form {
        width: 100%;
        display: flex;

        .searchPox {
          //width: calc(100% - 135px);
          //display: flex;
          //flex-direction: column;

          .liBox:first-child {
            .el-form-item {
            }
          }

          .liBox {
            width: 128px;
            display: inline-block;
            margin-right: 8px;

            .el-form-item {
              display: flex;
              margin-bottom: 0;

              .el-select, .el-input, .el-input__wrapper {
                width: 128px;
              }

              .el-radio {
                margin-right: 10px;
              }
            }
          }
        }

        .searchBtn {
          width: 720px !important;

          .el-checkbox__input {
            .el-checkbox__inner {
              background-color: #165DFF;
            }
          }

          .el-checkbox__input.is-focus {
            .el-checkbox__inner {
              background-color: #fff;
            }

            .el-checkbox__inner:after {
              border-color: #165DFF;
            }
          }
        }
      }

    }


    /*卡片*/

    .cardBox {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .cardContent {
        position: relative;
        margin: 16px 0 0 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border: 1px solid #E5E6EB;
        width: 24%;
        min-width: 268px;
        height: 246px;
        border-radius: 6px;
        background: #FFFFFF;
        overflow: hidden;

        .titleBox {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: calc(100% - 44px);
          cursor: pointer;
        }

        .topBox {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;
          height: 44px;

          .leftBox {
            display: flex;
            flex-direction: column;
            padding-left: 16px;
            justify-content: space-between;

            div:nth-child(1) {
              color: #1D2129;
              font-size: 15px;
              font-weight: bold;
            }

            div:nth-child(2) {
              color: rgba(0, 0, 0, .4);
              font-size: 12px;
            }
          }

          .rightBox {
            margin-right: 16px;
            text-align: right;
          }
        }

        .centerBox {
          height: 41px;
          display: flex;
          justify-content: space-between;
          padding: 0 16px;

          .leftBox {
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            div:nth-child(1) {
              color: #86909C;
              font-size: 12px;
            }

            div:nth-child(2) {
              color: #1D2129;
              font-size: 14px;
            }
          }

          .rigthBox {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            text-align: right;

            div:nth-child(1) {
              color: #86909C;
              font-size: 12px;
            }

            div:nth-child(2) {
              color: #1D2129;
              font-size: 14px;
            }

            width: 36%;
          }
        }

        .bottomBox {
          height: 41px;
          background-color: #F8F9FB;
          overflow: hidden;
          display: flex;
          align-items: center;

          div {
            flex: 1;
            text-align: center;
            color: #165DFF;
            font-size: 14px;
            cursor: pointer;
          }

          div:nth-child(2) {
            border-left: 1px solid rgba(0, 0, 0, .06);
            border-right: 1px solid rgba(0, 0, 0, .06);
          }

          div:last-child {
            color: #EF2121;
          }
        }
      }

      .cardContent:hover {
        box-shadow: 7px 7px 32px 0px rgba(158, 176, 207, 0.48);
      }
    }

    .cardBox.cardBox2 {
      .cardContent {
        height: 200px;
      }

      .centerBox {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: calc(100% - 58px);
        padding: 16px;

        .leftBox {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
        }
      }
    }

    .statusOnClass {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 60px;
      height: 22px;
      background: #E8FFEA;
      border-radius: 3px;
      color: #00B42A;

      .dotOnClass {
        border-radius: 50%;
        width: 6px;
        height: 6px;
        background: #00B42A;
      }
    }

    .statusOutClass {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 60px;
      height: 22px;
      background: #FFECE8;
      border-radius: 3px;
      color: #F53F3F;

      .dotOutClass {
        border-radius: 50%;
        width: 6px;
        height: 6px;
        background: #F53F3F;
      }
    }

    /*element表格*/


    .tableBox {
      width: 100%;
      height: 100%;
      padding: 0 !important;
      box-shadow: 0 0 0 0 !important;

      .operationBox {
        background-color: #fff;
        display: flex;
        justify-content: space-between;

        .tabBox {
          display: flex;
          justify-content: center;
          padding: 0 4px;
          align-items: center;
          width: 138px;
          background-color: #F2F3F5;
          border-radius: 2px;

          div {
            flex: 1;
            border-radius: 2px;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            background-color: #F2F3F5;
            color: #919193;
          }

          div:nth-child(1) {
            margin-right: 4px;
          }

          .active {
            background-color: #fff;
            color: #165DFF;
          }
        }
      }

      .operationUl {
        padding: 0;
        margin: 0;
        display: flex;
        //justify-content: space-between;
        align-items: center;

        .groupClass {
          width: 20px;
          height: 20px;
        }

        li {
          cursor: pointer;
          margin-right: 10px;
          margin-left: 0 !important;
          display: flex;
          align-items: center;

          img {
            width: 24px;
            height: 24px;
          }

          .is-checked {
            .el-switch__core {
              border: 1px solid #00b173;;
            }

            .el-switch__action {
              background-color: #00b173;
            }
          }

          .more {
            font-size: 20px;
            font-weight: bold;
          }
        }

        li:last-child {
          margin-right: 0;
        }
      }

      .editClass {
        cursor: pointer;
        color: #165DFF;
        //margin: 0 !important;
      }

      .deleteClass {
        cursor: pointer;
        color: #EF2121;
      }

      .el-table thead th {
        background: rgb(250, 250, 250);
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
      }

      .el-table__body-header .el-table__cell {
        padding: 0;
      }

      .userClass {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin-right: 4px;
      }

      .adressClass {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-left: 4px;
      }
    }

    //分页
    .footerBox {
      margin: 14px 0 24px 0;
      display: flex;
      justify-content: flex-end;
    }
  }

  //弹窗
  .dialogFormVisible {
    //min-width: 1000px;
    .el-dialog__header {
      border-bottom: 1px solid #efefef;
      margin: 0;
    }

    .el-dialog__footer {
      border-top: 1px solid #efefef;
      margin: 0;
    }

    .el-form-item {
      display: block;
      margin-bottom: 0;
      margin-right: 0;

      .el-select,
      .el-input-number {
        width: 100%;

        .el-input__inner {
          text-align: left;
        }
      }

      .el-form-item__content {
        display: block;

        .operation {
          margin: 5px 0 10px;
        }
      }

      .labelBox {
        display: flex;
        align-items: center;

        .el-icon.el-tooltip__trigger {
          margin-left: 8px;
          margin-right: 12px;
        }
      }

      .upload-demo {
        position: relative;

        .el-upload {
          width: 100%;
        }

        .uploadBox {
          width: 100%;
          height: 50px;
          line-height: 50px;
          border: 1px dashed #189bfe;
          border-radius: 8px;
          background-color: rgba(24, 155, 254, .05);

          .upBtnBox {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #189bfe;

            .el-icon {
              margin-right: 10px;
              font-size: 18px;
            }
          }

          .none {
            display: none;
          }
        }

        .el-upload-list {
          position: absolute;
          top: 0;
          width: 90%;
          margin-left: 5%;
        }
      }
    }

    //.formItem {
    //  .el-form-item__content {
    //    display: flex;
    //  }
    //
    //  .widthBox {
    //    flex: 1;
    //  }
    //}
    .contentItem {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      > p,
      > div {
        margin-right: 10px;
        display: flex;
        align-items: center;
      }

      .contItemBox {
        align-items: start;

        .symbol {
          margin-right: 10px;
          margin-top: 30px;
          font-size: 20px;
          text-align: center;

          p {
            cursor: pointer;
            margin: 0;
          }

          .activeSymbol {
            color: #165DFF;
          }
        }

        .symbol2 {
          margin-top: 50px;
        }
      }

      .addIcon,
      .delIcon {
        font-size: 17px;
        color: #000;
        cursor: pointer;
      }

      .addBox {
        width: 160px;
        height: 160px;
        border: 1px dashed #000;
        margin: 10px 0 0 10px;
        text-align: center;
        line-height: 160px;
        font-size: 40px;
        color: #000;
        cursor: pointer;
      }

      .contItem {
        display: flex;
        flex-direction: column;
        margin: 10px 0px 10px 0;

        .el-select {
          width: 160px;
          height: 30px;
        }

        .contTime .el-input {
          width: 110px;
          height: 30px;
        }

        .el-input__wrapper {
          height: 30px;
          background-color: #f6f6f6;
          color: #ccc;
          box-shadow: 0 0 0 0;
        }

        .contBox {
          width: 140px;
          height: 100px;
          background-color: #f6f6f6;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 0 10px;
          margin: 10px 0;
          position: relative;

          .el-select {
            width: calc(100% - 17px);

            .el-input__inner {
              padding-left: 0;
              font-size: 12px;
            }
          }

          .delIcon {
            position: absolute;
            top: 5px;
            right: 5px;
            color: #ccc;
            z-index: 1;
          }

          .center {
            p {
              color: #000;
            }

            //.val .el-input__wrapper {
            //  box-shadow: 0 0 0 0;
            //  background-color: #f6f6f6;
            //}
            .val .el-input__inner {
              font-size: 24px;
              color: #000;
            }

            .val .el-input__inner::placeholder {
              font-size: 12px;
              vertical-align: middle;
            }
          }

          .unit {
            text-align: right;
          }
        }

        .contItem:hover .delIcon {
          display: block;
        }
      }
    }
  }
}

</style>
